/** Tasks (old) presentation of a task closed in a status other than Completed (Not Required, Cannot Complete, a tenant status): it stays ticked, is not struck through, and names its status and reason (WBS-13176). */
import { isStampedTaskCompleted, isStampedTaskResolved, Task } from '@jms/model';
import { taskStatusExplanation, taskStatusTag } from '@workbuddy/entities/work.task/presentation/task.status.tag';
import { ConfirmServicePro } from '@workbuddy/ui/blocks/confirm';

/** Called by the tree row and the side editor; null for an open task and for a Completed one. */
export function closedTaskStatusTag(task: Task | null | undefined) {

    if (!task?.taskStatus || !isStampedTaskResolved(task) || isStampedTaskCompleted(task)) return null;

    // The old tab never loads the Tasks set, so the reason falls to the same-name rule; Not Required and Cannot Complete always carry a chosen one.
    const tag = taskStatusTag(task.taskStatus, task, undefined);
    if (!tag) return null;

    const reason = taskStatusExplanation(task.taskStatus, undefined).reason;

    return { ...tag, label: reason ? `${tag.label}: ${reason}` : tag.label };
}

/** Called before the tree checkbox or the editor button reopens a task; only a task closed as something other than Completed asks, since unticking it drops that status and its reason. */
export async function confirmReopenClosedTask(task: Task | null | undefined, confirmService: Pick<ConfirmServicePro, 'confirm'>): Promise<boolean> {

    if (!closedTaskStatusTag(task)) return true;

    return confirmService.confirm('Reopen task?', `This task is ${task.taskStatus.name}. Reopening it clears that status and its reason. Continue?`, 'warning');
}
